<div class="loader" [class.show]="show$ | async">
  <mat-progress-bar
    class="progress-bar"
    [mode]="mode$ | async"
    [value]="value$ | async">
  </mat-progress-bar>
</div>
